export default __webpack_public_path__ + "static/media/ca-2-rMIN.39f0043b.avif";